// ADR-0088 §Ingest follow-up. Runtime-validates the shape of
// ApiError.details on a WORKBOOK_INVALID (422) response into a structured
// AdminWorkbookParseIssue[] the preview screen can render as a list.
//
// Defensive by design: `ApiError.details` is `Record<string, unknown> |
// undefined` at the type level (core-api's error envelope isn't validated
// client-side), so this never trusts the shape — a response that doesn't
// match returns `undefined` and the caller falls back to the plain
// `error.message` string it already renders today. A single malformed
// entry rejects the whole array rather than filtering it out silently —
// understating how many rows are actually broken is worse than showing
// nothing structured at all.

import type { AdminWorkbookParseIssue } from "@bitacorapro/api-types";

function isParseIssue(v: unknown): v is AdminWorkbookParseIssue {
  if (typeof v !== "object" || v === null) return false;
  const rec = v as Record<string, unknown>;
  if (typeof rec["scope"] !== "string") return false;
  if (typeof rec["message"] !== "string") return false;
  if (rec["rowIndex"] !== undefined && typeof rec["rowIndex"] !== "number") return false;
  if (rec["column"] !== undefined && typeof rec["column"] !== "string") return false;
  return true;
}

export function parseWorkbookIssues(
  details: Record<string, unknown> | undefined
): AdminWorkbookParseIssue[] | undefined {
  const raw = details?.["issues"];
  if (!Array.isArray(raw)) return undefined;
  if (!raw.every(isParseIssue)) return undefined;
  return raw;
}
